import type { BotAvatarSet } from "@rakazo/contracts";
import { BotAvatar, resolvePersonaColorDef } from "@rakazo/ui-web";
import { useMemo } from "react";
import { FALLBACK_BOT_COLOR } from "./chat-shared";

/** The line above a bot's bubble: its avatar and name, in the bot's identity colour. */
export function BotSpeaker({
  name,
  identity,
  color,
  avatarSet,
}: {
  name: string;
  identity: string;
  color?: string;
  avatarSet?: BotAvatarSet;
}) {
  const colorDef = useMemo(() => resolvePersonaColorDef(identity, color), [identity, color]);
  return (
    <div
      className="mb-1.5 flex items-center gap-2 text-[13px] font-semibold tracking-tight"
      dir="auto"
      style={{ color: colorDef.light }}
    >
      <BotAvatar
        color={color ?? FALLBACK_BOT_COLOR}
        avatarSet={avatarSet}
        identity={identity}
        size={22}
      />
      {name}
    </div>
  );
}
